module.exports = __webpack_public_path__ + "static/media/maceio-al.eb2cba6c.jpg";